import React from 'react'
const Error = () => {
  return <div className="section section-center text-center"> there was and error</div>
}

export default Error
